import React, { useContext } from "react";
import Layout from "../../components/Layout";
import "react-toastify/dist/ReactToastify.css";
import "animate.css";
import Footer from "../../components/Footer";
import Select from "react-select";

import { useFormik } from "formik";
import * as yup from "yup";
import { UserContext } from "../../components/UserContext";
import { ToastContainer, toast } from "react-toastify";
import { meta } from "../../utils/meta";
import { Fade } from "./../../components/Animation";
import Link from "next/link";
import { useRouter } from "next/router";
// const responsive = {
//   Desktop: {
//     breakpoint: { max: 4000, min: 640 },
//     items: 1
//   },
//   mobile: {
//     breakpoint: { max: 640, min: 0 },
//     items: 1
//   }
// };

const ReferralPartner = () => {
  const route = useRouter();
  route.pathname === "/blog/[slug]"
  //const [product, productActive] = useState("solar");
  const { setloader } = useContext(UserContext);

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      mobile: "",
      email: "",
      subject: "",
      message: "",
      company: "",
      customer_first_name: "",
      customer_last_name: "",
      customer_mobile: "",
      customer_email: "",
    },
    validationSchema: yup.object({
      first_name: yup
        .string()
        .required("First Name is required")
        .matches(/^[A-Za-z]+$/, "Please enter valid Name"),
      last_name: yup.string().matches(/^[A-Za-z]+$/, "Please enter valid Name"),
      company: yup
        .string()
        .required("company Name is required")
        .matches(/^[A-Za-z]+$/, "Please enter valid Name"),
      mobile: yup
        .string()
        .required("Phone number is required")
        .matches(/^\d{10}$/, "Invalid Phone number"),
      email: yup
        .string()
        .required("Email is required")
        .email("Invalid email address"),
      subject: yup.string(),
      message: yup
        .string()
        .required("Message is required")
        .min(100, "Minimum length is 100 characters"),
      // customer variable
      customer_first_name: yup
        .string()
        .required("First Name is required")
        .matches(/^[A-Za-z]+$/, "Please enter valid Name"),
      customer_last_name: yup
      .string()
      .required("Last Name is required")
      .matches(/^[A-Za-z]+$/, "Please enter valid Name"),
      customer_mobile: yup
        .string()
        .required("Phone number is required")
        .matches(/^\d{10}$/, "Invalid Phone number"),
      customer_email: yup
        .string()
        .required("Email is required")
        .email("Invalid email address"),
    }),
    onSubmit: (formData: any, { resetForm }) => {
      submitSupportForm(formData, resetForm);
    },
  });
  const stateOptions = [
    { value: "California", label: "California" },
    { value: "Texas", label: "Texas" },
    { value: "Florida", label: "Florida" },
  ];
  const companyOptions = [
    { value: "Solar Quote", label: "Solar Quote" },
    { value: "Suntuity", label: "Suntuity" },
    { value: "SunPower", label: "SunPower" },
  ];

  const submitSupportForm = async (formData: any, resetForm: any) => {
    setloader(true);
    try {
      const res = await fetch(process.env.API_URL + "add/support-query", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      let result: any = await res.json();
      if (res.ok) {
        if (result) {
          resetForm({ values: "" });
          toast.success(result.msg);
        }
      } else {
        // console.log("result", result);
        // if(result.msg)toast.error(result.msg);
        if (typeof result) {
          for (const property in result) {
            toast.error(result[property][0]);
          }
        }

        if (result.Error) {
          toast.error(result.Error);
        }
      }
      setloader(false);
    } catch (e) {
      setloader(false);
      return null;
    }
  };
  return (
    <Layout
      title={meta.support.title}
      description={meta.support.description}
      keywords={meta.support.keywords}
    >
      <section className="bg-white">
      <div className="grid place-items-center home referral-banner banner-mob-height">
                    <div className="p-6 container m-auto md:px-12 xl:px-24">
                        <div className="">
                            <div className="">
                                <div className="flex flex-col justify-center max-w-2xl ">
                                    <h1 className="text-4xl xxs:text-4xl sm:text-7xl md::text-8xl font-configBold text-white">
                                        Create a brighter
                                    </h1>
                                    <h1 className="text-3xl sm:text-6xl md:text-7xl font-configBold text-white mb-4">
                                    future <span className="font-configLight">by</span> <span className="text-primary">referring</span> <span className="font-configLight">your friends and family</span>
                                    </h1>

                                    {/* <div className="my-8 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-102">
                                        <Link href="/referral/user">
                                            <a
                                                className="hover:opacity-90 text-black bg-primary font-configMedium px-14 py-3 text-base xxs:text-xl 2xl:text-xl rounded-sm"
                                            >
                                                Refer Now
                                            </a>
                                        </Link>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

        <section className="relative flex flex-col-reverse md:grid md:grid-cols-3 gap-2 py-8 lg:py-16 pb-6 container m-auto md:px-12">
          <div className="md:sticky top-28 md:h-screen px-6">
          <div className="flex flex-col items-start justify-start">
            {/* <img
            className="rounded"
              style={{ maxWidth: "200px" }}
              width="569"
              height="712"
              src="https://adam.catalystsol.com/wp-content/uploads/2022/08/adam-gonzalez.jpg"
            /> */}
            <img
                          src="/images/default-user-image.png"
                          alt="user image"
                          className="object-cover h-40 w-40 rounded-full"
                        />
            <h1 className="text-titleColor text-2xl xxs:text-3xl md:text-4xl font-configMedium mt-2.5">
              Armando Pacheco
            </h1>
            <div className="flex flex-col space-y-2 text-titleColor py-2">
                <p className="text-sm xxs:text-lg 2xl:text-2xl font-configMedium text-superSecondary hover:text-secondary">
                  <a href="mailto:apacheco@solarquote.com">
                    apacheco@solarquote.com
                  </a>
                </p>
                <p className="text-sm xxs:text-lg 2xl:text-2xl font-configMedium text-titleColor hover:text-secondary">
                  <a href="mailto:apacheco@solarquote.com">
                  9969336024
                  </a>
                </p>
                <div className="grid gap-2 text-bodyColor font-primaryMedium grid-cols-4">
                <Link href="https://www.facebook.com/Solar-Quote-103110515181282">
                <a target="_blank" rel="noreferrer">
                <img src="../images/facebook-icon.png"
                        className="hover:opacity-90 md:w-8 md:h-8 h-6 w-6 cursor-pointer"
                        alt="social-icon"
                      />
                  </a>
                </Link>
                <Link href="https://www.instagram.com/solarquoteinc">
                <a target="_blank" rel="noreferrer">
                <img src="../images/instagram-icon.png"
                        className="hover:opacity-90 md:w-8 md:h-8 h-6 w-6 cursor-pointer"
                        alt="social-icon"
                      />
                  </a>
                </Link>
                <Link href="https://www.linkedin.com/company/infinity-energy-construction/">
                <a target="_blank" rel="noreferrer">
                <img src="../images/linkedin.png"
                        className="hover:opacity-90 md:w-8 md:h-8 h-6 w-6 cursor-pointer"
                        alt="social-icon"
                      />
                  </a>
                </Link>
                <a target="_blank" rel="noreferrer" href="#">
                <img src="../images/tiktok.png"
                        className="hover:opacity-90 md:w-8 md:h-8 h-6 w-6 cursor-pointer"
                        alt="social-icon"
                      />
                  </a>
              </div>
            </div>
          </div>
          </div>

          <div className="col-span-2">
            <form
              onSubmit={formik.handleSubmit}
              className="referral-form m-auto bg-white flex flex-col gap-3 md:float-right sm:shadow rounded-md w-full p-4 sm:p-8"
            >
             

              <div className="flex flex-col justify-center ">
                <h1 className="mb-6 text-titleColor text-3xl xxs:text-4xl 2xl:text-5xl tracking-wide font-configMedium mt-3 ">
                  Referral Info:
                </h1>
                <div className="grid grid-cols-2 gap-4">
                  <div className="relative">
                    <p className="mb-1 text-sm xxs:text-base text-titleColor">
                      First Name <span className="text-primary"> *</span>
                      {formik.touched.customer_first_name &&
                      formik.errors.customer_first_name ? (
                        <span className="text-red-500 text-xs w-full ml-2">
                          {formik.errors.customer_first_name}
                        </span>
                      ) : null}
                    </p>
                    <input
                      {...formik.getFieldProps("customer_first_name")}
                      name="customer_first_name"
                      className="text-sm md:text-base focus:ring-2 focus:ring-titleColor focus:ring-offset-white  focus:outline-none p-2.5 border border-gray-300 rounded w-full placeholder-gray-400 text-bodyColor"
                    />
                  </div>
                  <div className="relative">
                    <p className="mb-1 text-sm xxs:text-base text-titleColor">
                      Last Name<span className="text-primary"> *</span>
                      {formik.touched.customer_last_name &&
                      formik.errors.customer_last_name ? (
                        <span className="text-red-500 text-xs w-full ml-2">
                          {formik.errors.customer_last_name}
                        </span>
                      ) : null}
                    </p>
                    <input
                      {...formik.getFieldProps("customer_last_name")}
                      name="customer_last_name"
                      className="text-sm md:text-base focus:ring-2 focus:ring-titleColor focus:ring-offset-white  focus:outline-none p-2.5 border border-gray-300 rounded w-full placeholder-gray-400 text-bodyColor"
                    />
                  </div>
                  <div className="relative">
                    <p className="mb-1 text-sm xxs:text-base text-titleColor">
                      Email <span className="text-primary"> *</span>
                      {formik.touched.customer_email &&
                      formik.errors.customer_email ? (
                        <span className="text-red-500 text-xs w-full ml-2">
                          {formik.errors.customer_email}
                        </span>
                      ) : null}
                    </p>
                    <input
                      placeholder="ex:abc@example.com"
                      {...formik.getFieldProps("customer_email")}
                      name="customer_email"
                      className="text-sm md:text-base focus:ring-2 focus:ring-titleColor focus:ring-offset-white  focus:outline-none p-2.5 border border-gray-300 rounded w-full placeholder-gray-400 text-bodyColor"
                    />
                  </div>
                  <div className="relative">
                    <p className="mb-1 text-sm xxs:text-base text-titleColor">
                      Mobile<span className="text-primary"> *</span>
                      {formik.touched.customer_mobile &&
                      formik.errors.customer_mobile ? (
                        <span className="text-red-500 text-xs w-full ml-2">
                          {formik.errors.customer_mobile}
                        </span>
                      ) : null}
                    </p>
                    <input
                      placeholder="ex:88888888"
                      {...formik.getFieldProps("customer_mobile")}
                      name="customer_mobile"
                      className="text-sm md:text-base focus:ring-2 focus:ring-titleColor focus:ring-offset-white  focus:outline-none p-2.5 border border-gray-300 rounded w-full placeholder-gray-400 text-bodyColor"
                    />
                  </div>
                  
                  
                  <div className="relative col-span-2 ">
                    <p className="mb-1 text-sm xxs:text-base text-titleColor">
                    Address
                    </p>
                    <input
                      name="customer_mobile"
                      className="text-sm md:text-base focus:ring-2 focus:ring-titleColor focus:ring-offset-white  focus:outline-none p-2.5 border border-gray-300 rounded w-full placeholder-gray-400 text-bodyColor"
                    />
                  </div>
                  <div className="grid col-span-2 grid-cols-3 gap-4">
                  
                  <div className="relative">
                    <p className="mb-1 text-sm xxs:text-base text-titleColor">
                    City
                    </p>
                    <input
                      
                      name="customer_mobile"
                      className="text-sm md:text-base focus:ring-2 focus:ring-titleColor focus:ring-offset-white  focus:outline-none p-2.5 border border-gray-300 rounded w-full placeholder-gray-400 text-bodyColor"
                    />
                  </div>
                  <div className="relative">
                    <p className="mb-1 text-sm xxs:text-base text-titleColor">
                    State
                    </p>

                    <div className="select-box-wrap border border-gray-300 rounded xl:w-full w-full text-bodyColor text-sm bg-white">
                      <Select options={stateOptions} />
                    </div>
                  </div>
                  <div className="relative">
                    <p className="mb-1 text-sm xxs:text-base text-titleColor">
                    Zip code
                    </p>
                    <input
                      name="customer_mobile"
                      className="text-sm md:text-base focus:ring-2 focus:ring-titleColor focus:ring-offset-white  focus:outline-none p-2.5 border border-gray-300 rounded w-full placeholder-gray-400 text-bodyColor"
                    />
                  </div>
                  </div>
                  <div className="relative">
                    <p className="mb-1 text-sm xxs:text-base text-titleColor">
                    Average Bill Amount
                    </p>
                    <input
                      name="customer_mobile"
                      className="text-sm md:text-base focus:ring-2 focus:ring-titleColor focus:ring-offset-white  focus:outline-none p-2.5 border border-gray-300 rounded w-full placeholder-gray-400 text-bodyColor"
                    />
                  </div>
              
                  <div className="relative">
                    <p className="mb-1 text-sm xxs:text-base text-titleColor">
                    Utility Company
                    </p>

                    <div className="select-box-wrap border border-gray-300 rounded xl:w-full w-full text-bodyColor text-sm bg-white">
                      <Select options={companyOptions} />
                    </div>
                  </div>
                </div>
              </div>

             

              <button
                type="submit"
                className="disabled:opacity-10 block p-3 my-4 mt-8 w-full hover:shadow-lg bg-primary text-white text-sm 2xl:text-lg xxs:text-lg font-primaryRegular uppercase text-center rounded"
              >
                Submit
              </button>
            </form>
          </div>
        </section>

        <section className="py-6 xl:py-20 bg-white">
        <div className="md:container md:m-auto flex flex-col-reverse 2md:grid 2md:grid-cols-2 xxs:gap-4">
          <Fade triggerOnce delay={500}>
            <div className="my-auto">
              <img src="https://adam.catalystsol.com/wp-content/uploads/2022/03/client-img.jpg"
                className="object-contain mx-auto w-3/5"
              />
            </div>
          </Fade>
          <div className="xl:pr-20 px-6 pt-6 pb-4 md:p-6 xl:p-0 my-auto">
            <h2 className="text-xl xxs:text-2xl tracking-wide capitalize text-primary font-primaryMedium">
            Customer Stories
            </h2>
            <div className="border bg-primary border-primary my-3 w-12"> </div>
            {/* <h2 className="text-2xl xxs:text-3xl sm:text-4xl md:text-5xl xl:text-5xl text-titleColor font-primarySemiBold">
            Customer Stories
            </h2> */}
            <p className="text-titleColor pt-2 xxs:py-4 text-base xxs:text-xl font-primaryMedium italic">
            “Solar Quote is among the world's leading renewable energy solutions provider that is revolutionizing and redefining the way sustainable energy sources are harnessed across the United States”
            </p>
          </div>
        </div>
      </section>
      </section>

      <Footer />
      <ToastContainer position="bottom-center" autoClose={8000} />
    </Layout>
  );
};

export default ReferralPartner;
